import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "passport"
const PassportIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.75 17.625C16.164 17.625 16.5 17.961 16.5 18.375S16.164 19.125 15.75 19.125H8.25C7.836 19.125 7.5 18.789 7.5 18.375S7.836 17.625 8.25 17.625z" />
          <path
            fillRule="evenodd"
            d="M12 4.5C14.9 4.5 17.25 6.85 17.25 9.75S14.9 15 12 15 6.75 12.65 6.75 9.75 9.1 4.5 12 4.5M11.273 10.5C11.356 11.813 11.65 12.594 11.901 13.034Q11.952 13.121 12 13.192 12.049 13.122 12.099 13.034C12.35 12.594 12.644 11.814 12.727 10.5zM8.325 10.5C8.553 11.622 9.283 12.562 10.27 13.076 10.023 12.435 9.831 11.595 9.771 10.5zM14.23 10.5C14.169 11.595 13.976 12.435 13.73 13.076 14.717 12.562 15.447 11.623 15.675 10.5zM10.27 6.423C9.282 6.938 8.552 7.878 8.324 9H9.771C9.83 7.905 10.023 7.065 10.269 6.423M11.9 6.466C11.65 6.906 11.356 7.687 11.273 9H12.727C12.644 7.687 12.35 6.906 12.099 6.466Q12.048 6.378 12 6.306 11.952 6.38 11.901 6.467M13.73 6.423C13.976 7.065 14.169 7.904 14.23 9H15.675C15.447 7.877 14.717 6.938 13.73 6.423"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M18.75 1.5C19.578 1.5 20.25 2.172 20.25 3V21C20.25 21.828 19.578 22.5 18.75 22.5H5.25C4.422 22.5 3.75 21.828 3.75 21V3C3.75 2.172 4.422 1.5 5.25 1.5zM5.25 21H18.75V3H5.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PassportIcon
